import React, { memo, useCallback } from 'react';
import { StandardTextFieldProps, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Controller } from 'react-hook-form';
import { AlyceTheme } from '@alycecom/ui';

import { ShippingAddressField } from '../../../../store/shipping/shipping.types';
import { findItem } from '../../../../../../helpers/list.helpers';
import { TState } from '../../../../../../store/countries/countries.types';

import { TFieldProps } from './Fields';

const useStyles = makeStyles<AlyceTheme>({
  hidden: {
    position: 'fixed',
    top: -100,
    left: -100,
  },
});

type TRecipientStateHiddenProps = TFieldProps<'reset' | 'getValues'> & {
  states: TState[];
} & Omit<StandardTextFieldProps, 'error' | 'onChange'>;

/* This input field required for work address autofill as well. Should exist on screen and be available as text field but work as dropdown  */
const RecipientStateHidden = ({
  control,
  reset,
  getValues,
  states,
  error,
  ...fieldProps
}: TRecipientStateHiddenProps): JSX.Element => {
  const classes = useStyles();

  const handleStateAutofill = useCallback(
    event => {
      const stateValue = event.target.value;
      const values = getValues();
      if (findItem('name')(stateValue)(states)) {
        reset({ ...values, state: stateValue });
      }
    },
    [reset, states, getValues],
  );

  return (
    <Controller
      control={control}
      name={ShippingAddressField.State}
      render={({ value }) => (
        <TextField
          classes={{ root: classes.hidden }}
          name={ShippingAddressField.State}
          fullWidth
          data-testid="ShippingAddressForm.StateTextHidden"
          label="state"
          data-private="lipsum"
          placeholder="state"
          value={value}
          onChange={handleStateAutofill}
          error={!!error}
          {...fieldProps}
        />
      )}
    />
  );
};

export default memo<TRecipientStateHiddenProps>(RecipientStateHidden);
